import { Component, Input, OnInit } from '@angular/core';
import { AutomatedEmailSettings } from '@app/models/recruiting/automated-email-settings.model';
import { AuthService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';

@Component({
    selector: 'app-recruiting-automated-email-settings-form',
    templateUrl: './automated-email-settings.form.html',
})
export class AutomatedEmailSettingsForm extends BaseForm implements OnInit {
    @Input() automatedEmailSettings: AutomatedEmailSettings = null;

    isLoading = false;

    templateId: number | string = 'free-form';
    userEmail = '';
    previousUserEmail = '';
    noReplyEmail = 'no-reply@hire.humi.ca';

    applicantMessageTemplates: ApplicantMessageTemplate[];

    constructor(
        private auth: AuthService,
        private notify: NotifyService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        try {
            const [applicantMessageTemplates] = await ApplicantMessageTemplate.all();
            this.applicantMessageTemplates = applicantMessageTemplates;
            this.userEmail = this.auth.account.email;
            this.previousUserEmail =
                this.automatedEmailSettings.replyTo !== this.noReplyEmail &&
                this.automatedEmailSettings.replyTo !== this.userEmail
                    ? this.automatedEmailSettings.replyTo
                    : null;
        } catch (err) {
            this.notify.error(err);
        }
        this.isLoading = false;
    }

    onTemplateIdChange(): void {
        const template = this.applicantMessageTemplates.find((t) => t.id === this.templateId);

        if (!template) {
            this.automatedEmailSettings.subject = '';
            this.automatedEmailSettings.body = '';
            return;
        }

        this.automatedEmailSettings.subject = template.subject;
        this.automatedEmailSettings.body = template.body;
    }
}
